/* @flow */

import "./SearchPageHeader.scss";

import * as React from "react";

import { Clearfix, ButtonToolbar, Well, ListGroup } from "react-bootstrap";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import SortDropdown from "../shared/article-badges/SortDropdown";
import SearchTabs from "./SearchTabs";
import { SearchQueryDebugInfo } from "./debug/SearchQueryDebugInfo";
import MobileNavigationAction from "../../../actions/MobileNavigationActions";
import { SearchQuery, SearchResultState } from "shared/src/types/articlesearch/SearchResult";
import { PageType } from "shared/src/types/PageType";

type Props = {
    onTabClick: (tab: number) => void;
    activeTab: number;
    query: SearchQuery;
    onChangeQuery: (query: SearchQuery) => void;
    filterPanelShowButton: React.ReactNode;
    searchResultFeedbackButton: React.ReactNode;
    specifiedSortValue: any;
    headline: React.ReactNode;
    subheadline: React.ReactNode;
    headerBreadcrumbs: React.ReactNode;
    pageType: PageType;
    searchResult: SearchResultState | undefined | null;
};

class SearchPageHeader extends React.Component<Props> {
    shouldRenderTabs() {
        return this.props.pageType === "SEARCH" && CountryUtil.getOptionalConfig().showContentSearchTab;
    }

    //shown in desktop view
    renderDesktopHeader() {
        const className =
            "test-ex-header search-page-header mfcss_pageheader hidden-xs hidden-xs-inline" +
            (this.shouldRenderTabs() ? " mfcss_pageheader-with-tabs" : "");
        return (
            <Clearfix className={className}>
                {this.props.headerBreadcrumbs}
                <div className="mfcss_pageheader--headline">
                    <h2>{this.props.headline}</h2>
                    {this.props.subheadline}
                    {this.props.searchResult &&
                        this.props.searchResult.result &&
                        this.props.searchResult.result.queryDebugInfo && (
                            <SearchQueryDebugInfo queryDebugInfo={this.props.searchResult.result.queryDebugInfo} />
                        )}
                </div>
                <div className="mfcss_pageheader--toolbar">
                    <SortDropdown
                        query={this.props.query}
                        selectedSortCriteria={this.props.specifiedSortValue}
                        onChangeQuery={this.props.onChangeQuery}
                    />
                    <div className="mfcss_pageheader--toolbar-buttons mfcss_pageheader--toolbar-buttons-collapsible">
                        <ButtonToolbar>
                            {this.props.searchResultFeedbackButton}
                            {this.props.filterPanelShowButton}
                        </ButtonToolbar>
                    </div>
                </div>
                <Clearfix />
                {this.shouldRenderTabs() && (
                    <SearchTabs onTabClick={this.props.onTabClick} activeTab={this.props.activeTab} />
                )}
            </Clearfix>
        );
    }

    //shown in mobile view/xs view
    renderMobileHeader() {
        const mobileHeadline = this.renderMobileHeadline();
        return (
            <div className="visible-xs visible-xs-inline">
                <div className="mfcss_mobile-navigation">
                    <ListGroup className="mfcss_pageheader--headline">{mobileHeadline}</ListGroup>
                    {this.shouldRenderTabs() && (
                        <SearchTabs onTabClick={this.props.onTabClick} activeTab={this.props.activeTab} />
                    )}
                    <Well className="well-sm">
                        <div className="flex-toolbar">
                            <div className="flex-toolbar-item flex-toolbar-item--auto">
                                <SortDropdown
                                    query={this.props.query}
                                    selectedSortCriteria={this.props.specifiedSortValue}
                                    onChangeQuery={this.props.onChangeQuery}
                                    isMobile
                                />
                            </div>
                            <ButtonToolbar>{this.props.filterPanelShowButton}</ButtonToolbar>
                        </div>
                    </Well>
                </div>
            </div>
        );
    }

    renderMobileHeadline() {
        //on categorypage with back arrow and being a link:
        if (this.props.pageType === "CATEGORY") {
            return (
                <div
                    className="list-group-item list-group-item-header list-group-item-back"
                    onClick={() => MobileNavigationAction.OpenSubcategory()}>
                    <h1>{this.props.headline}</h1>
                </div>
            );
            //on searchpage without link:
        } else {
            return (
                <div className="mfcss_mobile-navigation list-group">
                    <div className="list-group-item list-group-item-header">
                        <h1>{this.props.headline}</h1>
                    </div>
                </div>
            );
        }
    }

    render() {
        return (
            <div>
                {this.renderMobileHeader()}
                {this.renderDesktopHeader()}
            </div>
        );
    }
}

export default SearchPageHeader;
